var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {path:'/user/finance/wait',title:'提现打款'},
    {path:'/user/finance/log',title:'打款记录'},
]}},[_c('div',{attrs:{"slot":"left"},slot:"left"},[_c('el-menu',{staticStyle:{"height":"100%"},attrs:{"router":"","default-active":_vm.$route.path}},[_c('el-menu-item',{attrs:{"route":{name:'financeWait'}}},[_vm._v("提现打款")]),_c('el-menu-item',{attrs:{"route":{name:'financeLog'}}},[_vm._v("打款记录")])],1)],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }